<template>
  <div class="header-box">
    <el-header class="clearfix">
      <div class="heder-f fl" style="user-select: none;">
        <img :src="logoSrc" alt="" class="login" id="logo" />
        <h2>&nbsp;|&nbsp;{{CustomForm.systemName}}</h2>
      </div>
      <el-dropdown class="heder-r fr">
        <span class="logTea"><img src="../assets/img/tea.png" alt="" />
          <em>{{ userInfo.realName }}</em>
        </span>
        <el-dropdown-menu slot="dropdown" class="dropdown-show" v-show="false">
          <el-dropdown-item @click.native="handleEditPsd">修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="outLogin">安全退出</el-dropdown-item>
        </el-dropdown-menu>
        <el-dropdown-menu></el-dropdown-menu>
      </el-dropdown>
      <!--  考试数据包导出消息是数量 -->
      <div class="unReadInfo clearfix fr" @click="msgClick">
        <span class="el-icon-bell unReadIcon fl"></span>
        <span class="fl">消息</span>
        <span class="unReadNum fl" v-if="$store.state.sUnReadMsgCount>0">({{ $store.state.sUnReadMsgCount }})</span>
      </div>
      <!--  AI弹出框 -->
      <div class="unReadInfo clearfix fr">
        <span class="AI-circle fl"><span class="circle-mark">？</span></span>
        <span class="fl">24h AI咨询助手 <font class="AI-consult" @click="consultClick">立即咨询</font></span>
      </div>
    </el-header>

    <el-dialog
      :visible.sync="psdDialog"
      :title="isPassWordExpired == 1 ? '修改密码（您的密码已到期，请修改密码）': '修改密码'"
      :close-on-press-escape="false"
      :show-close="isPassWordExpired == 1 ? false: true"
      :close-on-click-modal="false"
      width="360px"
    >
      <!-- <template v-slot:content> -->
        <slot name="content" class="content">
          <div class="HeaderDialogMain">
            <el-form :model="psdRuleForm" :rules="rules" ref="psdRuleForm" class="editPsdForm" status-icon>
              <el-form-item label="新密码" prop="password" style="margin-bottom: 48px;">
                <el-input
                  v-model="psdRuleForm.password"
                  type="password"
                  autocomplete="new-password"
                ></el-input>
                <ots-password-tooltip></ots-password-tooltip>
              </el-form-item>
              <el-form-item label="确认密码" prop="confirmPassword">
                <el-input
                  v-model="psdRuleForm.confirmPassword"
                  type="password"
                  autocomplete="new-password"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </slot>
      <template v-slot:footer>
        <el-button round @click="psdDialog = false" v-if="isPassWordExpired !== 1">取消</el-button>
        <el-button type="primary" round @click="rightEditPsd('psdRuleForm')">确定</el-button>
      </template>
    </el-dialog>

    <div class="AI-fixed-top-right" v-if="aiContent.consultFlag">
      <div class="AI-top">
        <div class="AI-top-left">
          <div class="AI-top-left-logo">&nbsp;</div>
          <div class="AI-top-left-sep"></div>
          <div class="AI-top-left-name">{{ aiContent.systemDefaultName }}</div>
        </div>
        <div class="AI-top-right">
          <div class="AI-top-right-broom" @click="broomSession">&nbsp;</div>
          <div class="AI-top-right-close" @click="aiContent.consultFlag=false">&nbsp;</div>
        </div>
      </div>
      <div class="AI-middle" ref="messagesContainer">
        <div v-for="(item, index) in aiContent.sessionContent" :key="index">
          <div class="forItem" v-if="item.type == 'system'">
            <div class="AI-middle-left"></div>
            <div class="AI-middle-right">
              <div class="AI-middle-right-top">弘成慧考 | {{ aiContent.systemDefaultName }}</div>
              <div class="AI-middle-right-bottom" v-if="item.loading">正在为您搜索答案，请稍后...</div>
              <div class="AI-middle-right-bottom" v-if="!item.loading" v-html="markdownToHtml(item.content)"></div>
              <div class="AI-bottom-top" v-if="item.reGenerateFlag">
                <div class="AI-bottom-top-left" @click="reGenerate(index)">重新生成</div>
                <div class="AI-bottom-top-right" @click="copyContent(item)">复制</div>
              </div>
            </div>
          </div>
          <div class="forItem" v-if="item.type == 'system' && index == 0">
            <div class="AI-default">
              <div class="AI-default-Item" v-for="(item, index) in aiContent.defaultAnswer" :key="index" @click="goSubmit(index)">{{ item }}</div>
            </div>
          </div>
          <div class="forItem" v-if="item.type == 'custom'">
            <div class="AI-middle-left-custom"></div>
            <div class="AI-middle-right">
              <div class="AI-middle-right-top">{{ aiContent.customDefaultName }}</div>
              <div class="AI-middle-right-bottom-custom" v-html="markdownToHtml(item.content)"></div>
            </div>
          </div>
          <div class="forItem" v-if="item.type == 'separate'">
            <div class="AI-default">
              <div class="AI-default-Item-sep">--------------- 清空上下文 ---------------</div>
            </div>
          </div>
          <div class="forItem" v-if="item.type == 'separateSystem'">
            <div class="AI-middle-left"></div>
            <div class="AI-middle-right">
              <div class="AI-middle-right-top">弘成慧考 | {{ aiContent.systemDefaultName }}</div>
              <div class="AI-middle-right-bottom" v-html="markdownToHtml(item.content)"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="AI-bottom">
        <div class="AI-bottom-bottom">
          <div class="AI-bottom-bottom-left" @click="addNewSession">&nbsp;</div>
          <div class="AI-bottom-bottom-right">
            <el-input
              v-model="aiContent.inputMessage"
              type="textarea"
              :rows="5"
              placeholder="请在此提问..."
              resize="none"
              :autofocus="true"
              maxlength="1500"
              show-word-limit
              class="AI-bottom-bottom-right-input"
              @keyup.enter.ctrl.native="aiSubmitQuestion"
            >
            </el-input>
            <div class="external-suffix" @click="aiSubmitQuestion"></div>
            <div class="external-suffix-text">Ctrl+Enter</div>
          </div>
        </div>
      </div>
    </div>
    <div class="AI-fixed-bottom-right" @click="consultClick">
      <div class="AI-fixed-bottom-right-icon"></div>
      <div class="AI-fixed-bottom-right-text">24H 智能AI助手</div>
    </div>
  </div>
</template>

<script>
import { checkPwd, passWordStrength } from "@/common/verify.js";

import logoSet from "@/http/logoSet.js";
import { logoDefault } from "@/http/logoSet.js";
import {
  getUnreadCountFn,
  updateReadFn
} from '@/http/modules/exportDownInfo'
import {
  aiGetLastConversationFn,
  aiSubmitQuestionFn
} from '@/http/modules/ai/ai'
export default {
  name: "out-header",
  data() {
    return {
      userInfo: {},
      psdDialog: false,
      isPassWordExpired: 0,
      psdRuleForm: {
        // oldPsd:'',
        userId: "",
        password: "",
        confirmPassword: "",
        tenant: "",
      },

      CustomForm: {
        systemName: "弘成慧考平台"
      },

      rules: {
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: this.confirmPassword, trigger: "blur" },
        ],
      },
      logoSrc: "",
      // 未读的数量
      sUnReadNum:"",
      aiContent: {
        consultFlag: false,
        stopFlag: false,
        systemDefaultName: "弘小成",
        customDefaultName: "我",
        defaultAnswer:["如何创建考试批次","报名审核有几级流程","如何进行考场安排"],
        inputMessage: "",
        conversationId: "",
        baseAnswer: "您好，我是弘成慧考的客服助手，弘小成。我可以回答您在系统使用时遇到的任何问题，请问有什么可以帮您？",
        baseErrorAnswer: ["Token余额不足！"],
        sessionContent: [
          {
            type: "system",
            loading: false,
            reGenerateFlag: false,
            content: "您好，我是弘成慧考的客服助手，弘小成。我可以回答您在系统使用时遇到的任何问题，请问有什么可以帮您？",
          }
        ],
      },
    };
  },
  watch: {
    "psdDialog": function(value) {
      if (this.isPassWordExpired == 1 && value == false) {
        this.pasDialog = true;
      }
    },
  },
  created() {
    this.getCustomSet();
    this.getExportDownMsgInfo();
    this.getAIContent();
  },
  mounted() {
    this.$store.commit("setUserInfo", JSON.parse(localStorage.getItem("userInfo")));
    this.userInfo = this.$store.state.userInfo;
    // 密码到期：是否强制修改密码
    this.isMustEditPsd();
  },
  methods: {
    //打开AI窗口
    consultClick(){
      this.aiContent.consultFlag = !this.aiContent.consultFlag;
      this.scrollToBottom();
    },
    //清空会话列表
    broomSession() {
      if(this.aiContent.stopFlag) {
        this.$message.warning('请等待上一次回答完成');
        return;
      }
      const firstItem = this.aiContent.sessionContent[0];
      this.aiContent.sessionContent = [firstItem];
    },
    //重新生成
    reGenerate(index) {
      if(this.aiContent.stopFlag) {
        this.$message.warning('请等待上一次回答完成');
        return;
      }
      if(this.aiContent.sessionContent.length == 1){
        this.$message.warning('请先提问');
        return;
      }
      const filterContentList = this.aiContent.sessionContent.filter(item => item.type == 'custom')
      if(filterContentList.length >= 1){
        this.aiContent.inputMessage = this.aiContent.sessionContent[index-1].content;
        this.aiSubmitQuestion();
      }else{
        this.$message.warning('请先提问');
        this.aiContent.stopFlag = false;
        return;
      }
    },
    //拷贝生成的内容
    copyContent(item) {
      let createInput = document.createElement("input");
      createInput.value = this.markdownToHtml(item.content);
      document.body.appendChild(createInput);
      createInput.select();
      document.execCommand("Copy");
      createInput.style.display = "none";
      this.$message.success("该内容已复制");
    },
    //新建会话
    addNewSession() {
      if(this.aiContent.stopFlag) {
        this.$message.warning('请等待上一次回答完成');
        return;
      }
      this.aiContent.conversationId = "";
      this.aiContent.sessionContent.forEach(item => {
        if(item.type == 'system'){
          if(item.reGenerateFlag){
            item.reGenerateFlag = false;
          }
        }
      })
      let newSeparate = {
          type: "separate"
      }
      this.aiContent.sessionContent.push(newSeparate);
      this.scrollToBottom();
      let newDefault = {
          type: "separateSystem",
          loading: false,
          content: this.aiContent.baseAnswer
      }
      this.aiContent.sessionContent.push(newDefault);
    },
    //提交预设的问题
    goSubmit(index) {
      if(this.aiContent.stopFlag) {
        this.$message.warning('请等待上一次回答完成');
        return;
      }
      this.aiContent.inputMessage = this.aiContent.defaultAnswer[index];
      this.aiSubmitQuestion();
    },
    //获取会话列表
    async getAIContent() {
      const { code,data } = await aiGetLastConversationFn({size : 3});
      let tmpId = '';
      if(code && data){
        const filterData = data.filter(item => item.queryContent && item.returnAnswer);
        if(filterData.length > 0){
          const LastItem = filterData[filterData.length-1];
          this.aiContent.conversationId = LastItem.conversationId;

          filterData.forEach(item => {
            if(tmpId == ''){
              tmpId = item.conversationId;
            }else{
              if(tmpId != item.conversationId){
                tmpId = item.conversationId;
                let newSeparate = {
                    type: "separate"
                }
                this.aiContent.sessionContent.push(newSeparate);
                let newDefault = {
                    type: "separateSystem",
                    loading: false,
                    reGenerateFlag: false,
                    content: this.aiContent.baseAnswer
                }
                this.aiContent.sessionContent.push(newDefault);
              }
            }
            let newContent = {
              type: 'custom',
              content: item.queryContent,
            }
            this.aiContent.sessionContent.push(newContent);
            let newAnswer = {
              type: 'system',
              loading: false,
              reGenerateFlag: this.aiContent.conversationId == item.conversationId ? (this.aiContent.baseErrorAnswer.includes(item.returnAnswer) ? false : true) : false,
              content: item.returnAnswer,
            }
            this.aiContent.sessionContent.push(newAnswer);

          })
        }
      }
    },
    //提交问题
    async aiSubmitQuestion(){
      if(this.aiContent.stopFlag) {
        this.$message.warning('请等待上一次回答完成');
        return;
      }
      if(!this.aiContent.inputMessage){
        this.$message.warning('请输入提问的内容');
        return;
      }
      this.aiContent.stopFlag = true;
      let newContent = {
          type: "custom",
          conversationId: this.aiContent.conversationId,
          content: this.aiContent.inputMessage,
      }
      this.aiContent.sessionContent.push(newContent);
      this.scrollToBottom();
      let newAnswer = {
          type: "system",
          loading: true,
          reGenerateFlag: false,
          conversationId: this.aiContent.conversationId,
          content: ''
      }
      this.aiContent.sessionContent.push(newAnswer);
      this.scrollToBottom();
      let params = {
        conversation_id : this.aiContent.conversationId,
        queryContent : this.aiContent.inputMessage
      }
      this.aiContent.inputMessage = '';
      try {
        const { code,data,error } = await aiSubmitQuestionFn(params);
        const lastAnswer = this.aiContent.sessionContent[this.aiContent.sessionContent.length - 1];
        if(code){
          this.aiContent.conversationId = data.conversation_id;
          lastAnswer.loading = false;
          lastAnswer.reGenerateFlag = true;
          lastAnswer.content = data.answer;
        }else{
          lastAnswer.loading = false;
          lastAnswer.reGenerateFlag = false;
          if(this.aiContent.baseErrorAnswer.includes(error.msg)){ //为了后期扩展
            if(error.msg == this.aiContent.baseErrorAnswer[0]){
              lastAnswer.content = "<font color=red><b>Token余额不足！</b></font>";
            }else{
              lastAnswer.content = "抱歉，暂时无法回答您的问题，请稍后再试";
            }
          }else{
            lastAnswer.content = "抱歉，暂时无法回答您的问题，请稍后再试";
          }
        }
      }catch {
      }finally{
        this.aiContent.stopFlag = false;
      }
      this.scrollToBottom();
      this.aiContent.stopFlag = false;
    },
    //自动滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesContainer
        if (container) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    // 密码到期：是否强制修改密码
    isMustEditPsd() {
      this.isPassWordExpired = JSON.parse(localStorage.getItem("userInfo")).isPassWordExpired;
      if (this.isPassWordExpired === 1) {
        this.psdDialog = true;
      }
    },

    /***************************************
     * @getCustomSet 配置个性化LOGO,系统名
     ***************************************/
    getCustomSet(){
      let tenant = window.localStorage.getItem('tenant')
      let defaultLogo = require('@/assets/img/customDefault.png')
      this.$api.system.getSystemNameFN({tenant}).then(({data})=>{
        this.CustomForm.systemName = data.systemName ? data.systemName : '弘成慧考平台'
        this.logoSrc = data.isUsedLogo == 1 ? data.logoUrl ? data.logoUrl : defaultLogo : defaultLogo
      })
    },

    /***************************************
     * @getLogo 系统设置LOGO (已弃用)
     ***************************************/
    getLogo() {
      const tenant = window.localStorage.getItem("tenant");
      logoSet("admin", tenant)
        .then(({ code, data }) => {
          if (code == 1) {
            this.logoSrc = data;
          } else {
            this.logoSrc = logoDefault("admin")
          }
        }).catch(() => {
          this.logoSrc = logoDefault("admin")
        })
    },
    handleEditPsd() {
      this.psdDialog = true;
      this.psdRuleForm.password = "";
      this.psdRuleForm.confirmPassword = "";
    },
    rightEditPsd(psdRuleForm) {
      this.$refs[psdRuleForm].validate((valid) => {
        if (valid) {
          let editPsdQuery = {
            userId: this.userInfo.id,
            password: this.psdRuleForm.password,
            confirmPassword: this.psdRuleForm.confirmPassword,
            tenant: window.localStorage.getItem("tenant"),
          };
          this.$api.login.editPsd(editPsdQuery).then((res) => {
            if (res.code) {
              let userInfo = JSON.parse(localStorage.getItem("userInfo"));
              userInfo.isPassWordExpired = 0;
              this.isPassWordExpired = 0;
              localStorage.setItem("userInfo", JSON.stringify(userInfo));
              this.psdDialog = false;
              this.$message.success("密码修改成功！");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    confirmPassword(rule, value, callback) {
      if (value) {
        if (this.psdRuleForm.password !== this.psdRuleForm.confirmPassword) {
          callback(new Error("确认密码必须和新密码相同"));
        } else {
          callback();
        }
      }
      callback();
    },
    outLogin() {
      this.mixin_outLogin();
    },
    async getExportDownMsgInfo() {
      let oUnreadInfo = await getUnreadCountFn();
      // 更新未读数量
      this.$store.commit("updateUnReadMsgCount", oUnreadInfo.data);
      // this.sUnReadNum = this.$store.state.sUnReadMsgCount;
    },
    msgClick(){
      this.$router.push({ name: "exportDownInfo" });
    },
    markdownToHtml(text) {
      if (!text) return '';
      // 1. 将 \n\n 转换为 <p> 或 <br>
      let html = text
        // 将 \n\n 转换为段落分隔
        .replace(/\n\n/g, '</p><p>')
        // 将单个 \n 转换为 <br>
        .replace(/\n/g, '<br>')
        // 将 **文本** 转换为 <strong>文本</strong>
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        // 将 *文本* 转换为 <em>文本</em>（斜体）
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        // 将数字列表转换为 <li>
        .replace(/(\d+)\.\s+(.*?)(?=\n\d+\.|$)/g, '<li>$2</li>');
      // 如果有列表项，包装在 <ol> 中
      if (html.includes('<li>')) {
        html = html.replace(/<li>/g, '<ol><li>').replace(/<\/li>(?!.*<li>)/, '</li></ol>');
      }
      return `<p>${html}</p>`;
    }
  },
};
</script>

<style scoped lang="less">
.header-box {
  width: 100%;
}
.el-header {
  padding: 0 10px 0 18px;
  height: 60px;
  line-height: 60px;
  background: @c-006;
  box-shadow: 0px 4px 12px 0px rgba(0, 53, 128, 0.3);
  .heder-f {
    width: auto;
    h2 {
      color: #FFF;
      float: right;
      font-size: 18px;
    }
    height: 60px;
    text-align: left;
    color: #fff;
    .login {
      height: 42px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
    span {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .heder-r {
    margin-right: 30px;
    position: relative;
    .logTea {
      cursor: pointer;
      display: flex;
      justify-content: right;
      align-items: center;
      height: 60px;
      color: #fff;
      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 5px;
        text-align: right;
      }
      em {
        font-style: normal;
        color: #fff;
        max-width: 113px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
// .dropdown-show {
//   width: 150px!important;
// }

.title-msg {
  font-size: 16px;
  font-weight: 600;
  color: #15151a;
  position: relative;
  margin-top: 20px;
}
.title-msg:after {
  content: " ";
  position: absolute;
  left: -8px;
  top: 5px;
  width: 3px;
  height: 14px;
  background-color: #3388ff;
}
/deep/ .el-input__inner {
  width: 280px;
  height: 40px;
}
/deep/ .el-form-item__error {
  line-height: 16px;
}
.title-msg-top {
  margin-top: 0 !important;
  margin-bottom: 10px !important;
}
.textareaBox {
  width: 100% !important;
}
/deep/ .el-form-item {
  display: inline-block;
}
/deep/ .el-form-item__label {
  float: none;
}
/deep/ .el-form-item__content {
  margin-left: 0 !important;
  // margin-right: 50px;
}

.HeaderDialogMain {
  display: flex;
  .descript {
    padding-top: 18px;
    line-height: 24px;
  }
}
.editPsdForm {
  width: 300px;
}
.editPsdForm /deep/ .el-input {
  width: 280px;
}
.editPsdForm /deep/ .el-input__inner {
  width: 280px;
}
.pubMsg {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.colorBtn {
  font-size: 16px;
  color: #fff;
}
.dialog-footer /deep/ .el-button--default:hover {
  background: #ecf5ff;
  color: #176de6;
  border-color: #176de6 !important;
}
/deep/ .el-dialog{
  border-radius: 8px;
}
/deep/ .el-dialog__title {
  font-weight: 700;
}
/deep/ .el-dialog__body {
  padding: 32px;
}
/deep/ .el-dialog.auto-scroll .el-dialog__footer {
  padding-top: 0;
}
/deep/ .el-dialog .el-input {
  // width: 240px;
  height: 36px;
  line-height: 36px;
}
/deep/ .el-dialog .el-input__inner,
/deep/ .el-dialog .el-input__icon {
  height: 36px;
  line-height: 36px;
}
/deep/ .el-dialog .el-form-item__content {
  line-height: 1;
}
/deep/ .el-dialog .default-upload-container {
  width: 240px;
  height: 36px;
  line-height: 36px;
}
/deep/ .el-form-item__label {
  line-height: 1;
  padding-bottom: 16px;
}

/deep/ .el-dialog .el-pagination__sizes .el-input {
  width: 100px;
}
/deep/ .el-dialog .el-pagination__editor.el-input {
  width: 50px;
}
/deep/ .el-dialog .el-pagination__sizes .el-input__inner,
/deep/ .el-dialog .el-pagination__sizes .el-input__icon,
/deep/ .el-dialog .el-pagination__jump .el-input__inner {
  height: 28px;
  line-height: 28px;
}
/deep/ .el-radio-button__inner {
  margin-right: 16px;
  color: #45494d !important;
  background: #f4f5f8 !important;
  font-size: 13px;
  border-radius: 4px !important;
  border: 1px solid #dadde6 !important;
  padding: 10px 20px;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #ebf5ff !important;
  border: 1px solid #006aff !important;
  color: #006aff !important;
  box-shadow: none;
}
.dialog-footer /deep/ .el-button {
  width: auto;
  height: 30px;
  // line-height: 30px;
  border-radius: 15px;
  padding: 0 23px;
  box-sizing: border-box;
}
/deep/ .el-form-item__label {
  float: none !important;
  display: block;
  text-align: left;
  padding-bottom: 8px !important;
}
/deep/ .el-dialog.is-fullscreen {
  background: #f4f5f8;
  margin-top: 60px;
  margin-bottom: 0;
  height: calc(100% - 60px);
  .el-dialog__header {
    background: #fff;
    height: 64px;
    box-sizing: border-box;
    box-shadow: 0px -1px 0px 0px #f1f2f5;
    border-radius: 8 px 8 px 0 px 0 px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    .el-dialog__headerbtn{
      top: 23px;
    }
  }
}
/deep/ .el-dialog.is-fullscreen .el-dialog__body {
  padding-top: 0 !important;
}
.unReadInfo{
  margin-right: 14px;
  font-size: 14px;
  cursor: pointer;
  color: #ffffff;
  .unReadIcon{
    margin-top: 20px;
    font-size: 22px;
    margin-right: 4px;
  }
  .unReadNum{
    margin-left: 4px;
    display: inline-block;
    color: #FFBF00;
    font-weight: bold;
  }
}
.AI-circle{
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 16px;
  cursor: pointer;
  border:2px solid #fff;
  margin: 20px 5px 0px 0px;
  line-height: 16px;
  font-weight: bold;
  .circle-mark{
    margin-left: 4px;
  }
}
.AI-consult{
  color: #ffffff;
  cursor: pointer;
}
.AI-consult:hover {
  color: #CE8C78;
}

.AI-fixed-top-right{
  width: 400px;
  height: 600px;
  padding:20px;
  position: fixed;
  top: 59px;
  right: 20px;
  z-index: 9999;
  border-radius: 10px;
  background-color: #fff;
  border:1px solid #AAA;

  .AI-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    border-bottom: 1px solid #AAA;
    padding-bottom: 5px;
    margin-bottom: 10px;

    .AI-top-left{
      display: flex;
      .AI-top-left-logo{
        background-color: #006aff;
        background-image: url(../assets/img/customDefault.png);
        background-repeat: no-repeat;
        background-size: 100px auto;
        background-position: 5px;
        padding:5px;
        width:100px;
        height: 30px;
      }
      .AI-top-left-sep{
        height: 40px;
        margin: 0 18px;
        width: 0px;
        border-left:1px solid #AAA;
      }
      .AI-top-left-name{
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .AI-top-right{
      display: flex;
      .AI-top-right-broom{
        padding-top: 5px;
        background-image: url(../assets/img/broom.png);
        background-repeat: no-repeat;
        background-size: 25px auto;
        margin-left: 50px;
        filter: opacity(50%);
        cursor: pointer;
        width: 22px;
      }
      .AI-top-right-close{
        padding-right: 10px;
        margin-top: 5px;
        background-image: url(../assets/img/close.png);
        background-repeat: no-repeat;
        background-size: 15px auto;
        margin-left: 30px;
        padding-left: 20px;
        filter: opacity(70%);
        cursor: pointer;
      }
    }
  }
  .AI-middle{
    height: 400px;
    overflow-y: auto;
    .forItem{
      margin: 0px 0px 10px 0px;
      display: flex;
      .AI-middle-left{
        width:40px;
        height: 40px;
        margin: 13px 5px 0px 0px;
        background-color: #006aff;
        background-image: url(../assets/img/customDefault.png);
        background-repeat: no-repeat;
        background-size: 100px auto;
        background-position: 8px 5px;
      }
      .AI-middle-left-custom{
        width:40px;
        height: 40px;
        margin: 13px 5px 0px 0px;
        background-image: url(../assets/img/defaultHead.png);
        background-repeat: no-repeat;
        background-size: 46px auto;
        background-position: -3px -3px;
      }
      .AI-middle-right{
        flex: 1;
        word-wrap: break-word;
        word-break: break-all;
        overflow-wrap: break-word;
        .AI-middle-right-top{
          padding: 10px 0px 10px 5px;
        }
        .AI-middle-right-bottom{
          padding: 12px 10px;
          border-radius: 10px;
          line-height: 22px;
          background-color: #F2F2F2;
        }
        .AI-middle-right-bottom-custom{
          padding: 12px 10px;
          border-radius: 10px;
          line-height: 22px;
          background-color: #CAF982;
        }
        .AI-bottom-top{
          padding:10px 0px;
          display: flex;
          .AI-bottom-top-left{
            background-image: url(../assets/img/reload.png);
            background-repeat: no-repeat;
            background-size: 18px auto;
            margin-left: 10px;
            padding-left: 20px;
            filter: opacity(65%);
            cursor: pointer;
          }
          .AI-bottom-top-right{
            background-image: url(../assets/img/copy.png);
            background-repeat: no-repeat;
            background-size: 18px auto;
            margin-left: 50px;
            padding-left: 20px;
            filter: opacity(80%);
            cursor: pointer;
          }
        }
      }
      .AI-default{
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        padding:10px 0px 10px 45px;

        .AI-default-Item{
          padding: 10px 15px;
          white-space: nowrap;
          border: 1px solid #AAA;
          border-radius: 10px;
          cursor: pointer;
        }
        .AI-default-Item-sep{
          text-align: center;
          padding-left: 5px;
          filter: opacity(50%);
        }
      }
    }
  }
  .AI-bottom{
    .AI-bottom-bottom{
      display: flex;
      margin-top:20px;
      .AI-bottom-bottom-left{
        background-image: url(../assets/img/addNew.png);
        background-repeat: no-repeat;
        background-size: 35px auto;
        filter: opacity(50%);
        margin-top: 30px;
        cursor: pointer;
        width: 40px;
      }
      .AI-bottom-bottom-right{
        flex: 1;
        .AI-bottom-bottom-right-input{
          margin-left: 5px;
          width: 100%;
        }
        .AI-bottom-bottom-right-input /deep/ .el-textarea__inner {
          padding-right: 50px !important;
        }
        .external-suffix {
          background-image: url(../assets/img/plane.png);
          background-repeat: no-repeat;
          background-size: 30px auto;
          filter: opacity(50%);
          position: absolute;
          right: 16px;
          bottom: 42px;
          z-index: 10;
          width: 50px;
          height: 50px;
          cursor: pointer;
        }
        .external-suffix-text{
          position: absolute;
          font-size: 12px;
          right: 20px;
          bottom: 45px;
          filter: opacity(50%);
        }
      }
    }
  }
}
.AI-fixed-bottom-right {
  position: fixed;
  width: 90px;
  height: 50px;
  right: 10px;
  bottom: 50px;
  z-index: 9999;
  cursor: pointer;
  .AI-fixed-bottom-right-icon{
    background-image: url(../assets/img/robot.png);
    background-repeat: no-repeat;
    background-size: 40px auto;
    background-position: 27px 0px;
    width: 90px;
    height: 32px;
  }
  .AI-fixed-bottom-right-text{
    background-color: #89D6F8;
    text-align: center;
    color: #fff;
    padding: 10px 7px;
    border-radius: 8px;
  font-size: 10px;
  }
}
</style>